module.exports = __webpack_public_path__ + "img/homepage-quick-links-boxes-arrows-lincoln.a012b658.png";